module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-48.63c0678f.png";